import { Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import FormInput from "../../molecules/FormInput";
import useRefresh from "../../../hooks/useRefresh";
import FormTemplate from "../../templates/FormTemplate";
import { CompanyService } from "../../../services/api";
import { useTranslation } from "react-i18next";

interface CreateCompanyDialogProps {
  open: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

export default function CreateCompanyDialog(props: CreateCompanyDialogProps) {
  const { t } = useTranslation("Company");
  const refresh = useRefresh();
  const [name, setName] = useState("");
  const [regNo, setRegNo] = useState("");
  const [emails, setEmails] = useState<string[]>([]);
  const [phones, setPhones] = useState<string[]>([]);
  const [extRef, setExtRef] = useState("");

  useEffect(() => {
    if (!props.open) return;
    setName("");
    setRegNo("");
    setEmails([]);
    setPhones([]);
    setExtRef("");
    setExtRef("");
  }, [props.open]);

  const handleSubmit = async () => {
    const res = await CompanyService.createCompany({
      createCompanyBody: {
        emails,
        name,
        phones,
        extRef,
        addresses: [],
        regNo,
      },
    });
    if (res?.data?.success) {
      refresh();
      props.onClose?.();
    }
  };
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("CreateCompany")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
        confirm
      >
        <Stack spacing={2} sx={{ minWidth: { xs: 350, sm: 400, md: 500 } }}>
          <FormInput
            field="name"
            label={t("Name")}
            onChange={(v) => {
              setName(v as string);
            }}
            type="string"
            required
            value={name}
          />
          <FormInput
            field="regNo"
            label={t("RegNo")}
            onChange={(v) => {
              setRegNo(v as string);
            }}
            type="string"
            value={regNo}
          />
          <FormInput
            field="phones"
            label={t("Phones")}
            onChange={(v) => {
              setPhones(v as string[]);
            }}
            type="chip-list"
            value={phones}
          />
          <FormInput
            field="emails"
            label={t("Emails")}
            onChange={(v) => {
              setEmails(v as string[]);
            }}
            type="chip-list"
            value={emails}
          />
          <FormInput
            field="extRef"
            label={t("ExtRef")}
            onChange={(v) => {
              setExtRef(v as string);
            }}
            type="string"
            value={extRef}
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
